import React from 'react';
import { Stack } from '@fiverr-private/layout_components';
import type { SkillsGroup as ISkillsGroup } from '../../types';
import { SkillsGroup } from './SkillsGroup';

type SkillsGroupedProps = Readonly<{
    skillGroups: ISkillsGroup[];
}>;

export const SkillsGrouped = ({ skillGroups }: SkillsGroupedProps) => (
    <Stack direction="column" gap="8">
        {skillGroups.map((skillGroup) => (
            <SkillsGroup key={skillGroup.type.id} {...skillGroup} />
        ))}
    </Stack>
);
